import React from 'react'
import { useSelector } from 'react-redux'
import { ToastContainer, Toast } from 'toonswap-uikit'
import { useToast } from 'state/hooks'
import { State } from 'state/types'

const TOAST_Z_INDEX = 2147483647 // max z-index so toasts stay above modals/overlays

const ToastListener = () => {
  const toasts: Toast[] = useSelector((state: State) => state.toasts.data)
  const { remove } = useToast()

  const handleRemove = (id: string) => remove(id)

  const visibleToasts = toasts.filter(
    (toast) =>
      (typeof toast.title === 'string' && toast.title.trim().length > 0) ||
      (typeof toast.description === 'string' && toast.description.trim().length > 0),
  )

  if (!visibleToasts.length) {
    return null
  }

  return (
    <div data-toast-root style={{ position: 'fixed', inset: 0, zIndex: TOAST_Z_INDEX, pointerEvents: 'none' }}>
      <div style={{ pointerEvents: 'auto' }}>
        <ToastContainer toasts={visibleToasts} onRemove={handleRemove} />
      </div>
    </div>
  )
}

export default ToastListener
